import { FormType } from '../../../form-types';
import { WeightLossFieldAnswers } from '../questions';

export const wlusmonthly: FormType<WeightLossFieldAnswers> = {
  name: 'Weight Loss Followup',
  olderVersions: [
    'wlusmonthly_2025',
    'wlusmonthly_2024',
    'wlusmonthly_archive'
  ],
  questions: [
    {
      key: 'wlusFollowup_genderIdentify',
      next: {
        condition: {
          'wlusFollowup_genderIdentify.wlusFollowup_genderIdentify_male': true
        },
        key: 'wlusFollowup_weightAndHeight2025',
        els: 'wlusFollowup_pregnantOrBreastfeedingOrPlanningTo'
      }
    },
    {
      key: 'wlusFollowup_pregnantOrBreastfeedingOrPlanningTo',
      next: {
        condition: {
          'wlusFollowup_pregnantOrBreastfeedingOrPlanningTo.wlusFollowup_PregnantOrBreastfeedingOrPlanningTo_yes':
            true
        },
        key: 'wlusFollowup_ineligible',
        els: 'wlusFollowup_consentPregnancy2025'
      }
    },
    {
      key: 'wlusFollowup_consentPregnancy2025',
      next: {
        condition: {
          'wlusFollowup_consentPregnancy2025.consent': true
        },
        key: 'wlusFollowup_weightAndHeight2025',
        els: 'wlusFollowup_didNotConsent'
      }
    },
    'wlusFollowup_weightAndHeight2025',
    {
      key: 'wlusFollowup_healthChangesMedicationChanges2025',
      next: {
        condition: {
          'wlusFollowup_healthChangesMedicationChanges2025.yes': true
        },
        key: 'wlusFollowup_tellUsMoreAboutTheChangesInYourHealth',
        els: 'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication'
      }
    },
    'wlusFollowup_tellUsMoreAboutTheChangesInYourHealth',
    'wlusFollowup_sideEffects',
    {
      key: 'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication',
      next: {
        switch: [
          {
            condition: {
              'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication.wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication_withinThePastWeek':
                true
            },
            key: 'wlusFollowup_dateOfLastUse'
          },
          {
            condition: {
              'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication.wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication_withinThePastTwoWeeks':
                true
            },
            key: 'wlusFollowup_dateOfLastUse'
          },
          {
            condition: {
              'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication.wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication_withinThePastMonth':
                true
            },
            key: 'wlusFollowup_dateOfLastUse'
          },
          {
            condition: {
              'wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication.wlusFollowup_whenDidYouLastTakeYourPrescribedWeightLossMedication_itHasBeenOverAMonth':
                true
            },
            key: 'wlusFollowup_dateOfLastUse'
          }
        ],
        els: 'wlusFollowup_identifyClosestDose'
      }
    },
    'wlusFollowup_dateOfLastUse',
    'wlusFollowup_identifyClosestDose',
    {
      key: 'wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication',
      next: {
        condition: {
          'wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication.wlusFollowup_haveYouExperiencedSideEffectsFromYourCurrentMedication_yes':
            true
        },
        key: 'wlusFollowup_describeTheSideEffectsThatYouVeExperienced',
        els: 'wlusFollowup_medicationExperience2025'
      }
    },
    'wlusFollowup_describeTheSideEffectsThatYouVeExperienced',
    {
      key: 'wlusFollowup_medicationExperience2025',
      next: {
        switch: [
          {
            condition: {
              'previousWeightlossDrug.extras.drugTitration': 'alternative',
              'wlusFollowup_medicationExperience2025.no_weightloss_no_sideEffects':
                true
            },
            key: 'wlusFollowup_alternative_offerRapid'
          },
          {
            condition: {
              'previousWeightlossDrug.extras.drugTitration': 'alternative',
              'wlusFollowup_medicationExperience2025.no_weightloss_yes_sideEffects':
                true
            },
            key: 'wlusFollowup_alternative_offerBiweekly'
          },
          {
            condition: {
              'previousWeightlossDrug.extras.drugTitration': 'biweekly',
              'wlusFollowup_medicationExperience2025.no_weightloss_no_sideEffects':
                true
            },
            key: 'wlusFollowup_biweekly_offerAlternative'
          },
          {
            condition: {
              'previousWeightlossDrug.extras.drugTitration': 'rapid',
              'wlusFollowup_medicationExperience2025.no_weightloss_yes_sideEffects':
                true
            },
            key: 'wlusFollowup_rapid_offerBiweekly'
          },
          {
            condition: {
              'previousWeightlossDrug.extras.drugTitration': 'rapid',
              'wlusFollowup_medicationExperience2025.yes_weightloss_yes_sideEffects':
                true
            },
            key: 'wlusFollowup_rapid_offerBiweekly'
          },
          {
            condition: {
              'previousWeightlossDrug.extras.drugTitration': 'rapid'
            },
            key: 'wlusFollowup_reducationInCravings2025'
          },
          {
            condition: {
              'previousWeightlossDrug.extras.drugTitration': 'alternative'
            },
            key: 'wlusFollowup_reducationInCravings2025'
          },
          {
            condition: {
              'previousWeightlossDrug.extras.drugTitration': 'biweekly'
            },
            key: 'wlusFollowup_reducationInCravings2025'
          }
        ],
        els: 'wlusFollowup_biweekly_offerAlternative'
      }
    },
    {
      key: 'wlusFollowup_alternative_offerRapid',
      next: { key: 'wlusFollowup_reducationInCravings2025' }
    },
    {
      key: 'wlusFollowup_alternative_offerBiweekly',
      next: { key: 'wlusFollowup_reducationInCravings2025' }
    },
    {
      key: 'wlusFollowup_biweekly_offerAlternative',
      next: { key: 'wlusFollowup_reducationInCravings2025' }
    },
    {
      key: 'wlusFollowup_rapid_offerBiweekly',
      next: { key: 'wlusFollowup_reducationInCravings2025' }
    },
    'wlusFollowup_reducationInCravings2025',
    {
      key: 'wlusFollowup_continueTreatment2025',
      next: {
        condition: {
          'wlusFollowup_continueTreatment2025.changeMedication': true
        },
        key: 'wlusFollowup_ineligibleChangeMedication',
        els: 'wlusFollowup_otherInformationOrQuestionsDoYouHaveForTheDoctor'
      }
    },
    'wlusFollowup_otherInformationOrQuestionsDoYouHaveForTheDoctor',
    {
      key: 'wlusFollowup_consentCompounded',
      next: {
        condition: {
          'wlusFollowup_consentCompounded.consent': true
        },
        key: 'wlusFollowup_consentTruthfulness',
        els: 'wlusFollowup_didNotConsent'
      }
    },
    {
      key: 'wlusFollowup_consentTruthfulness',
      next: {
        condition: {
          'wlusFollowup_consentTruthfulness.wlusFollowup_consentTruthfulness_consent':
            true
        },
        key: 'wlusFollowup_consentGLP1GIP',
        els: 'wlusFollowup_didNotConsent'
      }
    },
    {
      key: 'wlusFollowup_consentGLP1GIP',
      next: {
        condition: {
          'wlusFollowup_consentGLP1GIP.wlusFollowup_consentGLP1GIP_consent':
            true
        },
        key: 'wlusFollowup_complete',
        els: 'wlusFollowup_didNotConsent'
      }
    },

    'wlusFollowup_ineligibleChangeMedication',
    'wlusFollowup_ineligible',
    'wlusFollowup_didNotConsent',
    'wlusFollowup_complete'
  ]
};
